import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Member from 'src/entities/Member';

import { updateMember } from '../../actions/member';
import Navigation from '../Navigation/global';

interface IProps {
  account: Member;
  updateMember: (member: Member) => void;
}

interface IState {
  account: Member;
  passwordConfirm: string;
}

class PasswordComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      account: this.props.account,
      passwordConfirm: ''
    };

    this.onChangeItem = this.onChangeItem.bind(this);
    this.updateMember = this.updateMember.bind(this);
  }

  render() {
    return (
      <div id="AccountPassword">
        <Navigation isLogoOnly={true} />

        <div id="Tabs">
          <Link to="/settings/account">
            <div className="Tab">登録情報</div>
          </Link>
          <div className="Tab TabSelected">パスワード</div>
          <Link to="/settings/picture">
            <div className="Tab">画像</div>
          </Link>
        </div>
        <div id="Content">
          <div className="ContentItem">
            <label>新しいパスワード</label>
            <input
              type="password"
              className="InputText"
              value={this.state.account.password}
              onChange={this.onChangeItem.bind(this, 'password')}
            />
          </div>

          <div className="ContentItem">
            <label>新しいパスワード（確認）</label>
            <input
              type="password"
              className="InputText"
              value={this.state.passwordConfirm}
              onChange={this.onChangeItem.bind(this, 'passwordConfirm')}
            />
          </div>

          <button onMouseUp={this.updateMember} onTouchEnd={this.updateMember}>
            更新
          </button>
        </div>
      </div>
    );
  }

  onChangeItem(item: string, e: any) {
    const account = Object.assign({}, this.state.account);
    if (item === 'password') {
      account.password = e.target.value;
      this.setState({
        account
      });
    } else if (item === 'passwordConfirm') {
      this.setState({
        passwordConfirm: e.target.value
      });
    }
  }

  updateMember(e: any) {
    if (this.state.passwordConfirm === this.state.account.password) {
      this.props.updateMember(this.state.account);
      alert('更新されました');
    } else {
      alert('パスワードが一致していません');
    }
  }
}

const mapStateToProps = (state: any) => ({
  account: state.Account
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateMember(member: Member) {
      dispatch(updateMember(member));
    }
  };
};

const Memo = connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordComponent);

export default Memo;



// WEBPACK FOOTER //
// ./src/components/Account/password.tsx